import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeLocationsReqConfig = () => ({
  endpoint: 'paya',
  type: 'get',
  slug: [
    'organizations',
    {
      type: 'payload',
      selector: ['organizationId'],
    },
    'locations',
    {
      type: 'payload.query',
      queryParameter: 'query',
      selector: 'query',
    },
  ],
});

const requestOptions = makeLocationsReqConfig();

export const consts = createReqConsts('payment-methods', 'locations');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/payment-methods/requests/locations-req.js